import React, { Children } from 'react';
import PropTypes from 'prop-types';
import MaxWidthContainer from '../MaxWidthContainer';
import Title from '../Title';
import { TextType } from '../Text';
import DescriptionRow from '../DescriptionRow';

import './DescriptionsSection.scss';

const className = 'c-DescriptionsSection';

const DescriptionsSection = ({ title, cards }) => {
  const renderCards = () =>
    Children.toArray(
      cards.map((item, i) => {
        const reversed = i % 2 === 0 ? false : true;

        return <DescriptionRow {...item} reversed={reversed} />;
      })
    );

  return (
    <MaxWidthContainer>
      <div className={className}>
        <Title text={title} />
        {renderCards()}
      </div>
    </MaxWidthContainer>
  );
};

DescriptionsSection.propTypes = {
  title: TextType,
  cards: PropTypes.array,
};

export default DescriptionsSection;
